export class AnalyticsTracker {
  constructor(config = {}) {
    this.config = {
      enabled: false,
      apiEndpoint: 'https://search.pixlapps.io/api/analytics',
      batchSize: 10,
      flushInterval: 30000, // 30 seconds
      apiKey: null,
      ...config
    };
    
    this.queue = [];
    this.domain = window.location.origin;
    this.sessionId = this.generateSessionId();
    this.flushTimer = null;
    
    if (this.config.enabled && this.config.apiKey) {
      this.startBatchTimer();
    }
  }

  generateSessionId() {
    return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  }

  track(eventData) {
    if (!this.config.enabled || !this.config.apiKey) return;
    
    const event = {
      ...eventData,
      domain: this.domain,
      sessionId: this.sessionId,
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent,
      url: window.location.href,
      referrer: document.referrer
    };
    
    this.queue.push(event);
    
    // Flush immediately if queue is full
    if (this.queue.length >= this.config.batchSize) {
      this.flush();
    }
  }

  trackSearch(query, results) {
    this.track({
      type: 'search',
      query: query.toLowerCase().trim(),
      resultCount: results.matches.length,
      hasResults: results.matches.length > 0,
      hiddenCount: results.hidden.length,
      queryLength: query.length
    });
  }

  trackClick(query, item) {
    this.track({
      type: 'click',
      query: query.toLowerCase().trim(),
      clickedItem: item.textContent.substring(0, 100)
    });
  }

  async flush() {
    if (this.queue.length === 0) return;
    
    const events = [...this.queue];
    this.queue = [];
    
    try {
      const response = await fetch(this.config.apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': this.config.apiKey,
          'X-Domain': this.domain
        },
        body: JSON.stringify({ events })
      });
      
      if (!response.ok) {
        console.error('Analytics failed:', response.status);
        // Re-queue events on failure
        this.queue.unshift(...events);
      }
    } catch (error) {
      console.error('Analytics error:', error);
      // Re-queue events on error
      this.queue.unshift(...events);
    }
  }

  startBatchTimer() {
    if (this.flushTimer) return;
    
    this.flushTimer = setInterval(() => {
      this.flush();
    }, this.config.flushInterval);
    
    // Flush on page unload
    window.addEventListener('beforeunload', () => {
      this.flush();
    });
  }

  stopBatchTimer() {
    if (this.flushTimer) {
      clearInterval(this.flushTimer);
      this.flushTimer = null;
    }
  }

  enable(apiKey) {
    this.config.enabled = true;
    this.config.apiKey = apiKey;
    this.startBatchTimer();
  }

  disable() {
    this.config.enabled = false;
    this.stopBatchTimer();
    this.flush(); // Flush any remaining events
  }

  setApiKey(apiKey) {
    this.config.apiKey = apiKey;
    if (this.config.enabled && apiKey) {
      this.startBatchTimer();
    }
  }
}